// extracted by mini-css-extract-plugin
export default {"Select":"gZJJvsYq0wkd9FHxJCAI"};